import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Content } from "./Content.js";
import { Divider } from "./Divider.js";
import { Footer } from "./Footer.js";
import { Header } from "./Header2.js";
import { Tabs } from "./Tabs2.js";
import { token } from "./token.js";
const WIDTH = "336px";
function Inspector({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(InspectorStyled, {
    ...props,
    children
  });
}
const InspectorStyled = styled.div.withConfig({
  displayName: "InspectorStyled",
  componentId: "sc-4jegg0-0"
})(["display:flex;flex-direction:column;box-sizing:border-box;width:", ";height:100%;border-left:1px solid ", ";background-color:", ";"], WIDTH, token.gray100a, token.white);
const StyledDivider = styled(Divider).withConfig({
  displayName: "StyledDivider",
  componentId: "sc-4jegg0-1"
})(["margin-right:calc(", " * -1);margin-left:calc(", " * -1);"], token.spacing6, token.spacing6);
Inspector.Header = Header;
Inspector.Tabs = Tabs;
Inspector.Content = Content;
Inspector.Divider = StyledDivider;
Inspector.Footer = Footer;
Inspector.styles = {
  width: WIDTH,
  transition: "0.2s ease-in-out"
};
export {
  Inspector
};
//# sourceMappingURL=Inspector.js.map
